"use client";

import { BloksRoute } from "@/data/routes/bloks.route";
import { ProductListing } from "../ProductListingPage/components/ProductListing";

interface Props {
  products: BloksRoute["getInitialSearchData"]["products"];
  pageSize: BloksRoute["getInitialSearchData"]["pageSize"];
  initialFilterData: BloksRoute["getInitialSearchData"]["initialFilterData"];
  preview: boolean;
  query?: string;
}

export const SearchPlp = ({ preview }: Props) => {
  return <ProductListing preview={preview} />;
};
